module.exports = __webpack_public_path__ + "img/武汉大学logo.e82854bb.png";